const tabs = () => {
    // Tabs
    const tabs = document.querySelectorAll('.tabheader__item'),
        tabsParent = document.querySelector('.tabheader__items'),
        tabsContent = document.querySelectorAll('.tabcontent');

    function hideTabsContent(){
        tabsContent.forEach(item => {
            item.classList.remove('show', 'fade');
            item.classList.add('hide');
        });

        tabs.forEach(item => {
            item.classList.remove('tabheader__item_active');
        });
    }

    function showTabsContent(i = 0){
        tabs.forEach((item) => {
            if (tabs[i] == item){
                tabs[i].classList.add('tabheader__item_active');
                tabsContent[i].classList.add('show', 'fade');
            }
        });
    }

    hideTabsContent();
    showTabsContent();

    tabsParent.addEventListener('click', (event) => {
        const target = event.target;

        if(target && target.classList.contains('tabheader__item')){
            tabs.forEach((item, i) => {
                if (item == target){
                    hideTabsContent();
                    showTabsContent(i);
                }
            });
        }
    });
}
export default tabs;